import { calculateFileSize } from '@pba/react-utils';
import type { Media } from 'models';
import { Button, Col, Icon, Row, Text } from 'ui';
import { useGetMediaSource } from 'features/media';

type P = {
  mediaData: Media;
};

const DownloadMedia = ({ mediaData }: P) => {
  const getMediaSource = useGetMediaSource();

  return (
    <Row gutter={['xxs', 0]}>
      <Col>
        <Icon icon="video-file" size="large" />
      </Col>
      <Col flex={1}>
        <Row>
          <Col span={24}>
            <Text>{mediaData.name}</Text>
          </Col>

          <Col span={24}>
            <Row gutter={['xs', 0]}>
              <Col>
                <Text size="small">{calculateFileSize(mediaData.size)}</Text>
              </Col>
              <Col>
                <Button navigate={{ external: true, to: getMediaSource({ id: mediaData.id }) }} type="link-primary">
                  Save
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default DownloadMedia;
